import styles from "./UserChatMessage.module.css";

interface Props {
    message: string;
    image?: string | null; // <-- agrega esto
}

export const UserChatMessage = ({ message, image }: Props) => {
    return (
        <div className={styles.container}>
            {image && (
                <img
                    src={image}
                    alt="Imagen adjunta"
                    className={styles.image}
                    style={{ maxWidth: "120px", maxHeight: "80px", marginRight: "8px", borderRadius: "4px" }}
                />
            )}
            <div className={styles.message}>{message}</div>
        </div>
    );
};
